import { createContext, useState } from 'react';
// import { apiPaths } from '@mirinae/shared/defines/paths';
// import httpAPI from '@mirinae/lessons/modules/apis/http';

const ProgressContext = createContext({});

// initializing progress state
const progressStateInit = {
    sections: {},
    lessonTracker: {},
    completedExercises: [],
    miniLessonEnters: [],
    updated: 0,
};

// example contents of the above, updated after every user action via a call to /lessons/progress
// see API docs for details: https://docs.google.com/document/d/1LxfafL_h9KVCF-y0VieSDHEfFKNZTiH63PH56NtiDfY/edit#

// Establishes ProgressContext via a custom use-hook.
//  returns as the context value and object containing the selection state and several useful updater functions
export function useProgressContext(player) {
    const [progressState, setProgressState] = useState(progressStateInit);

    const updateProgressState = (update) => {
        if (update.completedExercises)
            player.setCompletedExercises(update.completedExercises);
        setProgressState((prev) => ({ ...prev, ...update, updated: prev.updated + 1 }));
    };

    // ProgressContext value
    return {
        ...progressState,
        update: updateProgressState,
    };
}

export default ProgressContext;
